export default "__VITE_ASSET__Bhz2_zL2__"